import { ProductDetailViewEvent } from '@/usecases/event-bus-for-third-party/event'

export function handleProductDetailViewEvent(event: ProductDetailViewEvent): void {
  /**
   * CyberACE用
   * このイベントは送信なくて良いかも知れない
   * - CyberACEは過去SMbrandで契約していたが、現在は契約解除しているはずなので送信しなくていいかも
   * - MyColor以外のホストでも送信しているが、参照されていないことが確認できれば送信しなくていいかも
   *
   * @see https://my-color.esa.io/posts/1259
   * @see https://github.com/Everforth/growthpalette-front/issues/8144
   */
  window.dataLayer.push({
    pageType: 'productDetail',
    ecommerce: {
      detail: {
        products: event.sku.map(sku => ({
          id: sku.id,
          short_id: sku.short_id,
          name: event.root.name,
          price: sku.price,
          brand: event.root.brand,
          category: event.root.category.join(','),
        })),
      },
    },
  })
}
